import { AttributesMixin, define, Store, type } from "@type-r/models"
import { NotificationSubscriptionTypesLookup } from "../../api/lookups"
import { NotificationSubscription } from "../../api/notificationSubscription"

export interface NotificationSubscriptionDialogStore extends AttributesMixin<typeof NotificationSubscriptionDialogStore> { }
@define
export class NotificationSubscriptionDialogStore extends Store {
    static attributes = {
        notificationSubscription: type(NotificationSubscription),
        notificationTypes: type(NotificationSubscriptionTypesLookup),
    }
}
